import { type Team, type User } from '@atlaskit/user-picker';

export const UNKNOWN = 'Unknown';

export const UNKNOWN_USER: User = {
	id: UNKNOWN,
	name: UNKNOWN,
	type: 'user',
};

export const UNKNOWN_TEAM: Team = {
	id: UNKNOWN,
	name: UNKNOWN,
	type: 'team',
};
